import React, { useState } from 'react';

const VERSIONS = [
  {
    version: 'V1.0.0',
    label:   'YOU ARE HERE 🎯',
    status:  'current',
    date:    'Live now',
    items: [
      { done: true, text: 'Smart file storage that sorts itself with AI' },
      { done: true, text: 'Automatic labelling, text extraction & categories' },
      { done: true, text: 'Simple subscriptions & secure checkout' },
      { done: true, text: 'Installable app for your phone' },
      { done: true, text: 'One secure identity across everything (your GIDO)' },
      { done: true, text: 'Irish data residency' },
    ],
  },
  {
    version: 'V1.0.1',
    label:   'Launching 17 September',
    status:  'next',
    date:    'September 2026',
    items: [
      { done: false, text: 'Your own AI website builder — launching 17 September' },
      { done: false, text: 'Email your customers, GDPR-safe from your own domain' },
      { done: false, text: 'Online storefront & checkout' },
      { done: false, text: 'Ask your files questions in plain language' },
    ],
  },
  {
    version: 'V1.1.0',
    label:   'Coming soon',
    status:  'future',
    date:    'From August 2026',
    items: [
      { done: false, text: 'VAT-ready accounting — coming August 2026' },
      { done: false, text: 'Reach the right customers across your business' },
      { done: false, text: 'Your brand’s look across the whole portal' },
    ],
  },
  {
    version: 'V2.0.0',
    label:   'The bigger picture',
    status:  'future',
    date:    '2027',
    items: [
      { done: false, text: 'Inventory & supply management' },
      { done: false, text: 'More industry-specific AI packs' },
      { done: false, text: 'The full Smart business suite, working as one' },
    ],
  },
];

function Roadmap() {
  const [open, setOpen] = useState(false);

  return (
    <div className="section">
      <div
        className="section-header-collapsible"
        onClick={() => setOpen(!open)}
      >
        <h2 className="section-title">🗺️ Product Roadmap</h2>
        <span className="section-toggle">{open ? '▲' : '▼'}</span>
      </div>

      {open && (
        <div className="roadmap-grid">
          {VERSIONS.map((v) => (
            <div key={v.version} className={`roadmap-card ${v.status}`}>
              <div className="roadmap-version">{v.version}</div>
              <div className="roadmap-label">{v.label}</div>
              <div className="roadmap-date">{v.date}</div>
              <ul className="roadmap-items">
                {v.items.map((item, i) => (
                  <li key={i} className={item.done ? 'done' : 'pending'}>
                    {item.done ? '✅' : '🔵'} {item.text}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Roadmap;